import { css, type CSSObject } from "@emotion/react";
import { constants, typographyStyles } from "@newsela/angelou";

const { heading5Obj, fontFamily } = typographyStyles;

const coreBlue = { 700: "#0052C4", 500: "#106FF3" };
const white = constants.colors.ui.white[500];

const boldHeadingTextCss: CSSObject = {
  fontWeight: "bold",
  ...fontFamily.circular,
};

const gridDetailsCss: CSSObject = {
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
  gap: "1vw",
  marginTop: "0.5em",
};

const mainIdeaBoxBaseCss: CSSObject = {
  borderRadius: 50,
  padding: "1em",
  paddingTop: 0,
  border: `4px solid ${coreBlue[500]}`,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};

// --- Layout grid ---
export const mainIdeaGridCss = css({
  display: "grid",
  gridTemplateAreas: `
    "title"
    "mainIdea"
    "details"
  `,
  gridTemplateRows: "0.15fr 0.25fr 1fr",
  gridTemplateColumns: "1fr",
  maxHeight: "700px",
  aspectRatio: 11 / 8.4,
  background: white,
  padding: "16px",
  height: "100%",
  width: "100%",
  margin: "0 auto",
});

export const mainIdeaBoxCss = css({
  ...mainIdeaBoxBaseCss,
  "& > span, & > label": {
    display: "flex",
    justifyContent: "center",
    padding: "0.5em",
    justifySelf: "center",
    margin: "0 auto",
    ...heading5Obj,
    ...boldHeadingTextCss,
    borderBottom: `4px solid ${coreBlue[500]}`,
    width: "80%",
  },
});

export const mainIdeaTextareaCss = css({
  height: "66px",
});

export const mainIdeaParagraphCss = css({
  height: "66px",
  margin: 0,
});

export const detailsRowCss = css({
  ...gridDetailsCss,
});

export const detailBoxCss = css([
  mainIdeaBoxBaseCss,
  {
    padding: "0.5em 0.5em 0.6em",
    display: "flex",
    height: "100%",
    minHeight: "150px",
    label: {
      ...boldHeadingTextCss,
    },
  },
]);

export const detailBoxTextareaCss = css({
  height: "100%",
  maxHeight: "92%",
});
